import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// get Project list
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Project
export const addProjectList = (project: any) =>
    api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project: any) =>
    api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project: any) =>
    api.delete(url.DELETE_PROJECT, {headers: {project}});
